export default {"src":"/_next/static/media/watch-minor.08d7779b.svg","height":72,"width":62};